import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-050b8229"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ComplaintId" }
const _hoisted_2 = {
  key: 1,
  class: "ComplaintId__content"
}
const _hoisted_3 = {
  key: 0,
  class: "flex flex-col justify-center items-center mt-6"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1 text-sm text-gray-400" }, "Загрузка жалобы...", -1))
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "content__header" }
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_9 = { class: "content__block" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "content__block__title" }, "Оcновная информация:", -1))
const _hoisted_11 = { class: "content__block__main" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Имя:", -1))
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "email:", -1))
const _hoisted_16 = { key: 2 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Номер телефона:", -1))
const _hoisted_18 = { key: 3 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Номер накладной:", -1))
const _hoisted_20 = { key: 4 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Обвиняемый сотрудник:", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Тема:", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Обращение:", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Виновный отдел:", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Источник:", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Email:", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Наименование:", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Номер телефона:", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Виновный сотрудник:", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Дата согласования:", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Согласование:", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Компания:", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Дата создания:", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Объект жалобы:", -1))
const _hoisted_35 = {
  key: 0,
  class: "content__block"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_loader = _resolveComponent("loader")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_pretension_files = _resolveComponent("pretension-files")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state.is_failed)
      ? (_openBlock(), _createBlock(_component_failed_fetch, {
          key: 0,
          loading: _ctx.state.is_loading,
          text: "При получении жалобы произошла ошибка",
          onRefresh: _ctx.loadComplaint
        }, null, 8, ["loading", "onRefresh"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.state.is_loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_loader, { class: "primary" }),
                _hoisted_4
              ]))
            : (_ctx.state.complaint)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_page_title, {
                        title: `Жалоба (ID: ${_ctx.state.complaint.id})`
                      }, null, 8, ["title"]),
                      (_ctx.state.complaint.status)
                        ? (_openBlock(), _createBlock(_component_cheap, {
                            key: 0,
                            class: _normalizeClass(["small ml-5", {
                                primary: _ctx.state.complaint.status.id === 43,
                                yellow: _ctx.state.complaint.status.id === 44,
                                green: _ctx.state.complaint.status.id === 45,
                            }])
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.state.complaint.status.name), 1)
                            ]),
                            _: 1
                          }, 8, ["class"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_the_button, {
                      class: "second small text",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8,
                        _createTextVNode(" Назад ")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("div", _hoisted_11, [
                      (_ctx.isType41)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
                            _hoisted_13,
                            _createTextVNode(" " + _toDisplayString(_ctx.state.complaint.name), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.isType41)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
                            _hoisted_15,
                            _createTextVNode(" " + _toDisplayString(_ctx.state.complaint.email || '-'), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.isType41)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_16, [
                            _hoisted_17,
                            _createTextVNode(" " + _toDisplayString(_ctx.state.complaint.phoneNumber || '-'), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.isType41)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_18, [
                            _hoisted_19,
                            _createTextVNode(" " + _toDisplayString(_ctx.state.complaint.clientTitle || '-'), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.isType42)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_20, [
                            _hoisted_21,
                            _createTextVNode(" " + _toDisplayString(_ctx.state.complaint.clientTitle || '-'), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("p", null, [
                        _hoisted_22,
                        _createTextVNode(" " + _toDisplayString(_ctx.state.complaint.title || '-'), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_23,
                        _createTextVNode(" " + _toDisplayString(_ctx.state.complaint.content || '-'), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_24,
                        _createTextVNode(" " + _toDisplayString(_ctx.state.complaint.culpritSide || '-'), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_25,
                        _createTextVNode(" " + _toDisplayString(_ctx.state.complaint.source || '-'), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_26,
                        _createTextVNode(" " + _toDisplayString(_ctx.state.complaint.email || '-'), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_27,
                        _createTextVNode(" " + _toDisplayString(_ctx.state.complaint.name || '-'), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_28,
                        _createTextVNode(" " + _toDisplayString(_ctx.state.complaint.phoneNumber || '-'), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_29,
                        _createTextVNode(" " + _toDisplayString(_ctx.state.complaint.culpritEmployee || '-'), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_30,
                        _createTextVNode(" " + _toDisplayString(_ctx.formatDateFromBackend(_ctx.state.complaint.agreementDate) || '-'), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_31,
                        _createTextVNode(" " + _toDisplayString(_ctx.state.complaint.agreement || '-'), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_32,
                        _createTextVNode(" " + _toDisplayString(_ctx.state.complaint.companyName || '-'), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_33,
                        _createTextVNode(" " + _toDisplayString(_ctx.formatDateFromBackend(_ctx.state.complaint.createdAt) || '-'), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_34,
                        _createTextVNode(" " + _toDisplayString(_ctx.state.complaint.object || '-'), 1)
                      ])
                    ])
                  ]),
                  (_ctx.state.complaint.files.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        _createVNode(_component_pretension_files, {
                          files: _ctx.state.complaint.files,
                          title: "Файлы"
                        }, null, 8, ["files"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
        ]))
  ]))
}